// import Store from '@/store'
import i18n from '@/i18n'

const headerData = (vm, title) => {
    const headerVal = []
    headerVal[0] = vm.reportHeadData.orgName
    headerVal[1] = vm.reportHeadData.address
    headerVal[2] = vm.reportHeadData.heading
    headerVal[3] = title
    headerVal[4] = ''
    headerVal[5] = getHeadParam(vm)
    headerVal[6] = ''
    return headerVal
}

const excelBody = (vm) => {
    const listData = vm.report_data
    const listContractor = []
    listData.map((item, index) => {
        if (i18n.locale === 'en') {
            listContractor.push({
                'SL No': (index + 1),
                'Circular Memo No ': item.circular_memo_no,
                'Fiscal Year ': vm.fiscalYear(item.fiscal_year_id),
                'Organization ': vm.orgName(item.org_id),
                'Training Name ': vm.trainingName(item.training_title_id),
                'Venue Name ': vm.venueName(item.venue_id),
                'Start Date ': item.training_start_date,
                'End Date ': item.training_end_date,
                'Remarks ': item.remarks
            })
        } else {
            listContractor.push({
                'ক্রমিক সংখ্যা': vm.$n(index + 1),
                'সার্কুলার মেমো নং ': item.circular_memo_no,
                'অর্থবছর ': vm.fiscalYear(item.fiscal_year_id),
                'সংগঠন ': vm.orgName(item.org_id),
                'প্রশিক্ষণের নাম ': vm.trainingName(item.training_title_id),
                'স্থানের নাম ': vm.venueName(item.venue_id),
                'শেষ তারিখ ': vm.$d(new Date(item.training_start_date)),
                'শুরুর তারিখ ': vm.$d(new Date(item.training_end_date)),
                'মন্তব্য ': item.remarks
            })
        }
    })
    return listContractor
}

const getHeadParam = (vm) => {
    let head = ''
    head = vm.$t('globalTrans.organization') + ' : ' + (vm.search.org_id ? vm.orgName(vm.search.org_id) : vm.$t('globalTrans.all'))
    head = head + ', ' + vm.$t('elearning_config.training') + ' ' + vm.$t('elearning_config.name') + ' : ' + (vm.search.training_title_id ? vm.trainingName(vm.search.training_title_id) : vm.$t('globalTrans.all'))
    head = head + ', ' + vm.$t('grant_budget_management.fiscal_year') + ' : ' + (vm.search.fiscal_year_id ? vm.fiscalYear(vm.search.fiscal_year_id) : vm.$t('globalTrans.all'))
    return head
}

export default {
    headerData,
    excelBody
}
